import React, { Component } from "react";
import { Animated } from "react-animated-css";
import ProjectImgOne from "./img/first.gif";
import ProjectImgTwo from "./img/second.gif";
import ProjectImgThree from "./img/third.gif";
import ProjectImgFour from "./img/fourth.gif";
import ProjectImgFith from "./img/fith.gif";
import ProjectImgSixth from "./img/sixth.gif";
import ProjectImgSeveth from "./img/seveth.gif";
class ProjectsSection extends Component {
  render() {
    return (
      <div className="projectContainer">
        <h1 className="projectHeading" id="section3">
          Projects
        </h1>
        <div className="projectsContainer">
          <div>
            <h1 className="projectExplination">React, Redux, Firebase</h1>
            <a href="https://studentzone-fb65f.firebaseapp.com/">
              <img src={ProjectImgSeveth} />
            </a>
          </div>
          <div>
            <h1 className="projectExplination">Nodejs, Express, MongoDB</h1>
            <a href="https://github.com/DylanG157/ExpressMongoDB">
              <img src={ProjectImgSixth} />
            </a>
          </div>
          <div>
            {" "}
            <h1 className="projectExplination">Jquery , Javascript</h1>
            <a href="https://github.com/DylanG157/jqueryStoreProject">
              <img src={ProjectImgOne} />
            </a>
          </div>
          <div>
            <h1 className="projectExplination">django, nodejs</h1>
            <a href="https://github.com/DylanG157/DjangoWebsite">
              <img src={ProjectImgFith} />
            </a>
          </div>
          <div>
            <h1 className="projectExplination">CSS Models</h1>
            <a href="https://github.com/DylanG157/BeefStro">
              <img src={ProjectImgFour} />
            </a>
          </div>
          <div>
            <h1 className="projectExplination">Javascript , CSS</h1>
            <a href="https://github.com/DylanG157/BikeShopWithCart">
              <img src={ProjectImgTwo} />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectsSection;
